import { render, staticRenderFns } from "./IbxLoadingList.vue?vue&type=template&id=0f75f135"
import script from "./IbxLoadingList.vue?vue&type=script&lang=js"
export * from "./IbxLoadingList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports